import { render, staticRenderFns } from "./verdatos.vue?vue&type=template&id=011054b9"
import script from "./verdatos.vue?vue&type=script&lang=js"
export * from "./verdatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports